exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".organizations-page{padding:10px}.organizations-page .add-organization{margin-bottom:10px}", ""]);

// exports
